import authenticatedRouteStrategies from './authenticatedRouteStrategies';
import unauthenticatedRouteStrategies from './unauthenticatedRouteStrategies';

export const DEEPLINK_STRATEGY_TYPES = {
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
};

export class DeepLinkRouteStrategyFactory {
  constructor(type) {
    this.type = type; // 'authenticated' or 'unauthenticated'
  }

  createStrategies() {
    return this.type === 'authenticated'
      ? this.createAuthenticatedStrategies()
      : this.createUnauthenticatedStrategies();
  }

  createAuthenticatedStrategies() {
    return authenticatedRouteStrategies;
  }

  createUnauthenticatedStrategies() {
    return unauthenticatedRouteStrategies;
  }

  findMatchingStrategy(context) {
    const strategies = this.createStrategies();
    return Object.entries(strategies)
      .sort(([, a], [, b]) => b.order - a.order)
      .find(([, strategy]) => strategy.matches(context));
  }

  getRoute(context) {
    const [, matchedStrategy] = this.findMatchingStrategy(context) || [];

    return matchedStrategy?.getRoute(context) || '/';
  }
}
